import { render, staticRenderFns } from "./transfer-cargo.vue?vue&type=template&id=89ce9a32&"
import script from "./transfer-cargo.vue?vue&type=script&lang=js&"
export * from "./transfer-cargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports